import React from 'react';
import PowerAnalysisD3 from '../../components/coach/charts/power-analysis-graph/PowerAnalysisD3';

interface PowerAnalysisD3PrototypePageProps {
  sessionId: string | null;
}

const PowerAnalysisD3PrototypePage: React.FC<PowerAnalysisD3PrototypePageProps> = ({
  sessionId,
}) => {
  // Wrap in explicit height container to match main dashboard behavior
  // This ensures ResizeObserver can properly calculate dimensions during resize
  // Pass activeTab="technique" to enable the ResizeObserver retry logic
  // that handles visibility timing issues used by the dashboard path
  return (
    <div className="h-[500px] sm:h-[600px] lg:h-[700px]">
      <div className="h-full flex flex-col">
        <PowerAnalysisD3 sessionId={sessionId} activeTab="technique" />
      </div>
    </div>
  );
};

export default PowerAnalysisD3PrototypePage;
